export enum PusherEvent {
  TicketChanged = 'TICKET_CHANGED',
}
